import { Card, CardContent, Skeleton, Typography } from '@mui/material';
import { REPORT_TYPES } from 'admin/reports/reportUtils';
import { Report, ReportType } from 'generated/graphql';

interface Props {
  isLoading: boolean;
  reports?: Report[];
  reportType: ReportType;
}

export const ReportStatsCard: React.FC<Props> = ({ isLoading, reportType, reports }) => {
  const validReports = reports?.filter((report) => report.published);

  const lastWeekTimestamp = new Date();
  lastWeekTimestamp.setDate(lastWeekTimestamp.getDate() - 7);

  const uniqueClientsTotal = new Set(validReports?.map((report) => report.client.id)).size;

  const clientFirstReportMap = validReports?.reduce((acc, report) => {
    if (!acc[report.client.id] || report.creationTimestamp < acc[report.client.id]) {
      acc[report.client.id] = report.creationTimestamp;
    }
    return acc;
  }, {} as Record<string, Date>);

  const uniqueClientsLastWeek = Object.entries(clientFirstReportMap || {}).filter(
    ([, timestamp]) => timestamp >= lastWeekTimestamp,
  ).length;

  return isLoading ? (
    <Skeleton height={96} variant="rectangular" />
  ) : (
    <Card>
      <CardContent>
        <Typography component="div" variant="h5">
          {`${uniqueClientsTotal} klientov s vygenerovaným výstupom ${REPORT_TYPES[reportType]}`}
        </Typography>
        <Typography color="text.secondary">{`+${uniqueClientsLastWeek} za posledných 7 dní`}</Typography>
      </CardContent>
    </Card>
  );
};
